import {
    CAR_LINK_BASE,
    TRUCK_LINK_BASE,
    MOTORCYCLE_LINK_BASE,
    PART_LINK_BASE,

    CAR_RENT_LINK_BASE,

    SERVICE_LINK_BASE,
    TOOL_LINK_BASE,
    AGRI_LINK_BASE,
    CONSTRUCTION_LINK_BASE,
    TRAILER_LINK_BASE,

    BUY_LINK_BASE,

    BUY_CAR_LINK_BASE,
    BUY_TRUCK_LINK_BASE,
    BUY_MOTORCYCLE_LINK_BASE,
    BUY_PART_LINK_BASE,
    BUY_CONSTRUCTION_LINK_BASE,
    BUY_TRAILER_LINK_BASE,
    BUY_TOOL_LINK_BASE,
    BUY_AGRI_LINK_BASE,
    HEAVY_LINK_BASE,
} from '@constants/searchFormLinks'

const ICON_DIMEN = { width: 28, height: 28 }

const osobowe = { t: 'Osobowe', to: CAR_LINK_BASE, svg: 'osobowe', alt: 'Samochody osobowe', title: 'Samochody osobowe' }
const dostawcze = { t: 'Dostawcze', to: TRUCK_LINK_BASE, svg: 'dostawcze', alt: 'Samochody dostawcze', title: 'Samochody dostawcze' }
const motocykle = { t: 'Motocykle', to: MOTORCYCLE_LINK_BASE, svg: 'motocykle', alt: 'Motocykle', title: 'Motocykle' }
const czesci = { t: 'Części', to: PART_LINK_BASE, svg: 'czesci', alt: 'Części samochodowe', title: 'Części samochodowe' }
const wynajem = { t: 'Wynajem', to: CAR_RENT_LINK_BASE, svg: 'wynajem', alt: 'Wynajem samochodów', title: 'Wynajem samochodów' }
const serwis = { t: 'Serwis', to: SERVICE_LINK_BASE, svg: 'serwis', alt: 'Serwis samochodowy', title: 'Serwisy samochodowe' }
const narzedzia = { t: 'Narzędzia', to: TOOL_LINK_BASE, svg: 'narzedzia', alt: 'Narzędzia warsztatowe', title: 'Narzędzia warsztatowe' }
const rolnicze = { t: 'Rolnicze', to: AGRI_LINK_BASE, svg: 'rolnicze', alt: 'Maszyny rolnicze', title: 'Maszyny rolnicze' }
const budowlane = { t: 'Budowlane', to: CONSTRUCTION_LINK_BASE, svg: 'budowlane', alt: 'Maszyny budowlane', title: 'Maszyny budowlane' }
const przyczepy = { t: 'Przyczepy', to: TRAILER_LINK_BASE, svg: 'przyczepy', alt: 'Przczepy samochodowe', title: 'Przyczepy samochodowe' }
const ciezarowe = { t: 'Ciężarowe', to: HEAVY_LINK_BASE, svg: 'ciezarowe', alt: 'Samochody ciężarowe', title: 'Samochody ciężarowe' }
const kupie = { t: 'Kupię', to: BUY_LINK_BASE, svg: 'kupno', alt: 'Kupię samochód', title: 'Kupię auto' }
const sprzedam = { t: 'Sprzedam', to: CAR_LINK_BASE, svg: 'sprzedaz', alt: 'Ogłoszenia sprzedaży aut' }
const pozostale = { t: 'Pozostale', to: PART_LINK_BASE, alt: 'Pozostałe' }

const buyOsobowe = { t: 'Osobowe', to: BUY_CAR_LINK_BASE, svg: 'osobowe', alt: 'Samochody osobowe', title: 'Samochody dostawcze ogłoszenia sprzedam' }
const buyDostawcze = { t: 'Dostawcze', to: BUY_TRUCK_LINK_BASE, svg: 'dostawcze', alt: 'Samochody dostawcze', title: 'Samochody dostawcze ogłoszenia sprzedam' }
const buyMotocykle = { t: 'Motocykle', to: BUY_MOTORCYCLE_LINK_BASE, svg: 'motocykle', alt: 'Motocykle', title: 'Motocykle ogłoszenia sprzedam' }
const buyCzesci = { t: 'Części', to: BUY_PART_LINK_BASE, svg: 'czesci', alt: 'Części samochodowe', title: 'Części samochodowe ogłoszenia sprzedaży' }
const buyNarzedzia = { t: 'Narzędzia', to: BUY_TOOL_LINK_BASE, svg: 'narzedzia', alt: 'Narzędzia warsztatowe', title: 'Sprzedaż narzędzi warsztatowych' }
const buyRolnicze = { t: 'Rolnicze', to: BUY_AGRI_LINK_BASE, svg: 'rolnicze', alt: 'Maszyny rolnicze', title: 'Sprzedaż maszyn rolniczych' }
const buyBudowlane = { t: 'Budowlane', to: BUY_CONSTRUCTION_LINK_BASE, svg: 'budowlane', alt: 'Maszyny budowlane', title: 'Sprzedaż maszyn budowlanych' }
const buyPrzyczepy = { t: 'Przyczepy', to: BUY_TRAILER_LINK_BASE, svg: 'przyczepy', alt: 'Przczepy samochodowe', title: 'Sprzedaż przyczep samochodowych' }

const frontpageLinks = [
    osobowe,
    dostawcze,
    czesci,
    ciezarowe,
    [
        'Pozostałe kategorie',

        motocykle,
        wynajem,
        serwis,
        narzedzia,
        rolnicze,
        budowlane,
        przyczepy,
        kupie,
    ],
]

const sellLinks = [
    osobowe,
    dostawcze,
    czesci,
    ciezarowe,
    motocykle,
    wynajem,
    serwis,
    narzedzia,
    rolnicze,
    budowlane,
    przyczepy,
    kupie,
]

const buyFrontpageLinks = [
    buyOsobowe,
    buyDostawcze,
    buyMotocykle,
    buyCzesci,
    buyBudowlane,
    buyPrzyczepy,
    buyNarzedzia,
    buyRolnicze,
    sprzedam,
]

export {
    frontpageLinks,
    buyFrontpageLinks,
    sellLinks,
    ICON_DIMEN,
}